import folder from './folder';
import post from './post';
export default { folder, post };
